export default __webpack_public_path__ + "static/media/Northernlights01.c76234a2.webp";